import {DailyReport} from "../DailyReport";
import _ from "lodash";

class GamesTopupReport extends DailyReport {
    getConstructorStates() {
        return {
            providers: [],
            providerRegionMap: {},
            ...super.getConstructorStates()
        }
    }

    getSubgroupFromGroupDataMeta(metaData) {
        return metaData.provider_id.toString();
    }

    getInitialRegionDisplay(regions) {
        let currentRegionDisplay = _.get(this.state, 'displayRegions', {});
        if (_.isEmpty(currentRegionDisplay)) {
            return [true].concat(Array(regions.length-1).fill(false));
        }
        return regions.map(region => _.get(currentRegionDisplay, region.key, false));
    }

    updateOtherStatesFromResponse(response, needToUpdateInitialState) {
        super.updateOtherStatesFromResponse(response, needToUpdateInitialState);
        if (!needToUpdateInitialState) {
            return;
        }

        let providers = [];
        let providerKeysSet = new Set();
        let providerRegionMap = {};
        response.data.forEach(groupData => {
            let metaData = _.get(groupData, 'meta_data', {});
            let providerId = metaData.provider_id.toString();
            let providerLabel = metaData.provider_label;
            let regionKey = metaData.region;

            if (!providerKeysSet.has(providerId)) {
                providers.push({key: providerId, label: providerLabel});
                providerKeysSet.add(providerId);
                providerRegionMap[providerId] = regionKey;
            }
        });
        providers.sort();
        this.setState({
            providers: providers,
            providerRegionMap: providerRegionMap
        });
    }

    getSubgroups() {
        return this.state.providers;
    }

    getRegionKeyFromSubgroup(subgroup) {
        return this.state.providerRegionMap[subgroup.key];
    }

    onRegionToggle(selectedRegionKey) {
        let displayRegions = this.state.displayRegions;
        Object.keys(displayRegions).forEach(region => displayRegions[region] = false);
        displayRegions[selectedRegionKey] = true;
        this.setState({displayRegions});
    }

    isAbleToSelectAllRegions() {
        return false;
    }
}

export {GamesTopupReport};